// libraries
import React, { useState } from "react";
import Rating from "react-rating";
import { AnimatePresence } from "framer-motion";

// components
import ReviewModal from "../ReviewModal/ReviewModal";

// styles
import styles from "./styles.module.scss";

// assets
import starFilled from "src/assets/images/details/star_filled.svg";
import star from "src/assets/images/details/star.svg";

const FirstReview = ({ data, setReFetch }) => {
  const [isShow, setIsShow] = useState(false);

  const toggle = (_refetch) => {
    setIsShow(!isShow);

    if (_refetch) {
      setReFetch(true);
    }
  };

  return (
    <>
      <div className={styles.first_review}>
        <button onClick={() => toggle()}>
          <img src={starFilled} alt="star" /> <span>Rate Event</span>
        </button>
        <div className={styles.rating__wrapper}>
          <Rating
            emptySymbol={<img src={star} alt="star" />}
            fullSymbol={<img src={starFilled} alt="filled star" />}
            readonly
          />
        </div>
        <p>Be the first to rate this Event</p>
      </div>
      <AnimatePresence>
        {isShow && <ReviewModal toggle={toggle} data={data} />}
      </AnimatePresence>
    </>
  );
};

export default FirstReview;
